<template>
  <div class="footer">
    <!-- <div class="footer-content">
      <ul class="d-flex justify-content-center">
        <li>
          <a href="#">{{ $t("footer_connect.who_we_are") }}</a>
        </li>
        <li>
          <a href="#">{{ $t("footer_connect.contact") }}</a>
        </li>
        <li>
          <a href="#">{{ $t("footer_connect.legal") }}</a>
        </li>
        <li>
          <a href="#">{{ $t("footer_connect.cookies") }}</a>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<style scoped>
  .footer-content ul li {
    list-style: none;
    margin-right: 20px;
    font-size: 14px;
    font-weight: 300;
    color: #1e347d;
  }
  .footer-content ul li a {
    text-decoration: none;
    color: #1e347d;
  }
  .footer-content ul li a:hover {
    color: #1e347d;
  }
</style>
